import React, { useEffect, useState } from 'react'

export default function ResponseCard({academic_status, status, reason, handleResubmit, newSubjects}) {

  const [className, setClassName] = useState('')

  useEffect(() => {
    if (status === "Rejected") {
      setClassName("text-bg-danger")

    } else if (status === "Approved") {
      setClassName("text-bg-success")
    }

  }, [status])
  console.log('acadmic', academic_status)
  return (
    <div className={`card mb-3 text-center ${className}`} style={{maxWidth: "20rem", margin: "auto", marginTop:'20%', color: 'black'}}>
    <div class="card-body">
      <h5  class="card-title"> <strong> حالة الطلب  </strong>  </h5> <hr/>
      {academic_status === "DISM" && status === "Pending" ?
          <p class="card-text"> لا يمكنك التسجيل لأن حالتك الأكاديمية: مفصول. يرجى مراجعة مكتب تسجيل القسم. </p>
          : null}
          { status === "Approved"  ?  <div>  
            <p class="card-text"> تم القبول </p> 
              المواد : {newSubjects.join(', ')}
              </div> 
          
          : ""}
          { status === "Rejected"  ?    <p class="card-text">  تم الرفض </p>  : ""}
          { status === "Pending" && newSubjects?.length  ?    <p class="card-text">  يرجى الانتظار، سيتم مراجعة الطلب من قبل المرشد, الانتظار قد يصل الى 24 ساعة</p>  : ""}
      {  reason ?    <p class="card-text">  <strong > ملاحظات  </strong> : {reason} </p> : ''}
    { status === "Rejected" ?  <button class="btn btn-light" onClick={handleResubmit}> التسجيل من جديد </button> : "" }
    </div>
  </div>
  )
}
